function DeleteTasksController(
  $http,
  $window,
  $log,
  analyticsService,
  confirmationDialog
) {
  const $ctrl = this;

  function deleteConfirmedAction() {
    const taskArray = [];
    $ctrl.tasks.map(t => taskArray.push(t.id));

    $http({
      method: 'DELETE',
      url: 'api/tasks',
      headers: {
        'Content-Type': 'application/json'
      },
      data: taskArray
    }).then(
      () => {
        analyticsService.trackEvent(
          'Tasks management',
          'Delete all tasks in view'
        );
        $window.location.reload();
      },
      response => {
        $log.log('deleteConfirmedAction error: ', response);
      }
    );
  }

  $ctrl.deleteAll = () => {
    confirmationDialog.confirm('CONFIRM_DELETE_TASKS', deleteConfirmedAction);
  };
}

const deleteTasks = {
  restrict: 'E',
  bindings: {
    tasks: '<'
  },
  controller: [
    '$http',
    '$window',
    '$log',
    'analyticsService',
    'confirmationDialog',
    DeleteTasksController
  ],
  template: `<button class="btn btn-ghost mr1"
        ng-click="$ctrl.deleteAll()"
        tooltip-placement="bottom"
        uib-tooltip="{{:: 'DELETE_ALL_TASKS' | translate }}"
        aria-label="{{:: 'DELETE_ALL_TASKS' | translate }}">

        <i class="fa fa-trash-o"></i>
    </button>`
};

export default function (ngModule) {
  ngModule.component('deleteTasks', deleteTasks);
}
